// extracted by mini-css-extract-plugin
export default {"buttonToTopic":"ToTopic_buttonToTopic__1pvi+","showButton":"ToTopic_showButton__pGJAp","upper":"ToTopic_upper__vXR9V"};